/**
 * POST /site/requests (v0.1.210, Sercan 19 Oct 2026: "bize projeleri hakkında soru sorabilsinler", "arada ufak tefek
 * cad işlerini göndersinler ücretsiz yapalım"): the cadgaragepro.com form. A visitor asks about a project or sends a
 * small CAD job; Twin keeps it as an e-mail conversation, so the Temsilci drafts the reply and Sercan approves it on
 * Telegram. Public: the only route the static site reaches, behind its own rate limit and checks.
 */
import { z } from 'zod';
// v0.1.221: notify, "tell me when this file is on sale" from a coming-soon product page (second opinion, 21 Oct 2026).
export const SITE_REQUEST_KINDS = ['question', 'free_cad', 'notify'];
/** Turkish names of the kinds, for the Telegram line. */
export const SITE_REQUEST_KIND_LABELS = Object.freeze({
    question: 'proje sorusu',
    free_cad: 'ücretsiz küçük CAD işi',
    notify: '"satışa çıkınca haber ver" talebi',
});
/** The only page origin the form is accepted from (Origin header, with X-Twin-Request: 1). */
export const SITE_REQUEST_ORIGINS = Object.freeze(['https://cadgaragepro.com']);
/** A request is refused when the form was sent faster than a person fills it in. */
export const SITE_REQUEST_MIN_FILL_MS = 3_000;
/** At most this many requests a day from the whole site; more is a flood, not visitors. */
export const SITE_REQUESTS_PER_DAY = 40;
const line = (max) => z
    .string()
    .max(max)
    .transform((value) => value.replace(/\s+/g, ' ').trim());
export const siteRequestBodySchema = z.strictObject({
    kind: z.enum(SITE_REQUEST_KINDS),
    name: line(80).optional(),
    email: z
        .string()
        .trim()
        .max(200)
        .regex(/^[^\s@<>"',;]+@[^\s@<>"',;]+\.[a-z]{2,}$/i),
    vehicle: line(120).optional(),
    message: z
        .string()
        .max(4000)
        .transform((value) => value.trim())
        .refine((value) => value.length >= 20, { message: 'too_short' }),
    /** Honeypot: a field people never see; anything in it is a bot. */
    website: z.string().max(200).optional(),
    /** How long the form was open before it was sent, measured by the page (ms); bots send at once. */
    fillMs: z.number().int().nonnegative().max(86_400_000),
    /** The visitor agreed that we keep the request to answer it (privacy page). */
    consent: z.literal(true),
    /** v0.1.225: the product a notify request waits for (the coming-soon page's SKU); Twin writes once it is listed. */
    sku: z
        .string()
        .regex(/^[A-Z0-9-]{3,40}$/)
        .optional(),
});
export const siteRequestResponseSchema = z.strictObject({ received: z.literal(true) });
//# sourceMappingURL=site-request.js.map